import { Divider, MenuItem } from "@mui/material";
import { /* ContentCopy as ContentCopyIcon,  */Edit as EditIcon, Delete as DeleteIcon } from "@mui/icons-material";
import Add from "./Add";
import Edit from "./Edit";
import Remove from "./Remove";
import { AddBulk } from "./AddBulk";

export function ActionsDialogPage({ open, close, menu, instance, reportAction }) {
  return (<>
    <Add
      open={open === 1}
      close={close}
      menu={menu}
      reportAction={reportAction} />
    <Edit
      open={open === 2}
      close={close}
      menu={menu}
      instance={instance}
      reportAction={reportAction} />
    <Remove
      open={open === 3}
      close={close}
      menu={menu}
      instance={instance}
      reportAction={reportAction} />
    <AddBulk
      open={open === 5}
      close={close}
      menu={menu}
      reportAction={reportAction} />
  </>)
}

export function ActionsMenuPage({ t, action }) {
  // 2: edit, 3: delete
  return (<>
    <MenuItem onClick={() => { action(2); }} disableRipple>
      <EditIcon /> {t('button_text_edit')}
    </MenuItem>
    {/* <MenuItem onClick={() => { action(4); }} disableRipple>
      <ContentCopyIcon /> {t('button_text_copy')}
    </MenuItem> */}
    <Divider sx={{ my: 0.5 }} />
    <MenuItem onClick={() => { action(3); }} disableRipple>
      <DeleteIcon color="error" /> {t('button_text_delete')}
    </MenuItem>
  </>)
}